import fire from '@store/firebase';
import { IQuest } from '@typings/quest/questTypes';
import { getAllDocsLength } from '@store/firebase/counter';
import { appendEditHistory } from '@store/firebase/utils/editHistory';

const firestore = fire.firestore();

export async function addAndGetDocId({ ref, data }) {
  return ref
    .add({
      ...data,
      createdAt: new Date(),
      updatedAt: new Date(),
    })
    .then((res) => res.id)
    .catch((err) => console.log(err.message));
}

export type UpdateQuestProps = {
  data: Partial<IQuest>;
  collectionPath?: string; // default: 'quest'
  docId?: string;
  editedBy?: string;
};

function sanitize<T extends Record<string, any>>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj || {}).filter(([_, v]) => v !== undefined),
  ) as T;
}

export async function updateQuest({ data, collectionPath = 'quest', docId, editedBy }: UpdateQuestProps) {
  const ref = firestore.collection(collectionPath);
  const currentDocsLength = await getAllDocsLength(collectionPath);

  const cleanData = sanitize(data || {});

  let _docId: string = docId || '';
  if (!_docId) {
    _docId = await addAndGetDocId({ ref, data: cleanData });
  }

  // 수정 이력: Firestore에서 누적된 editHistory를 읽고, 새 제목(스냅샷)을 히스토리에 저장
  let editHistoryPatch: Record<string, any> = {};
  if (docId && editedBy) {
    const currentDoc = await ref.doc(docId).get();
    const currentData = currentDoc.data();
    editHistoryPatch = {
      lastEditedBy: editedBy,
      editHistory: appendEditHistory(
        currentData?.editHistory,
        editedBy,
        undefined,
        (cleanData as any).title, // 새로 저장하는 제목(스냅샷)
      ),
    };
  }

  const newData: Partial<IQuest> = sanitize({
    ...cleanData,
    updatedAt: new Date(),
    priority: (cleanData as any).priority ?? currentDocsLength,
    id: _docId,
    ...editHistoryPatch,
  });

  await ref.doc(_docId).set(newData, { merge: true }).catch((err) => console.log(err.message));

  return _docId;
}
